import {
  LOADING_DATA_ON_PAGE_LOAD_SIMILAR_ITEMS,
  SIMILAR_ITEMS_INITIALISATION_FAILURE
} from "../../../modules/similarItems/constants";
import isAppOnline from "../../../../providers/applicationOnlineStatusProvider";
import getData from "./getData";
import { getUserIdentity } from "../../../modules/identity/actions";

const attemptSetup = dispatch => {
  dispatch({ type: LOADING_DATA_ON_PAGE_LOAD_SIMILAR_ITEMS, payload: true });
  if (!isAppOnline()) {
    dispatch({ type: SIMILAR_ITEMS_INITIALISATION_FAILURE });

    return [];
  }

  return [dispatch(getUserIdentity()), dispatch(getData())];
};

export default attemptSetup;
